<div class="row" *ngIf="order">
    <div class="col-lg-3">
        <div class="consumption-numbers">
            <div class="number">{{order?.hoursAssigned}} ({{(order?.hoursAssigned / 8).toFixed(2) }}d)</div>
            <div class="title">{{'order.budget.summary.hoursAssigned' | translate | uppercase }}</div>
        </div>
        <div class="consumption-numbers">
            <div class="number">{{order?.hoursSpent}} ({{(order?.hoursSpent / 8).toFixed(2) }}d)</div>
            <div class="title">{{'order.budget.summary.hoursSpent' | translate | uppercase }}</div>
        </div>
        <div class="consumption-numbers">
            <div class="number"> {{order?.hoursResidual}} ({{(order?.hoursResidual / 8).toFixed(2) }}d)</div>
            <div class="title">{{'order.budget.summary.hoursResidual' | translate | uppercase }}</div>
        </div>
    </div>
    <div class="col-lg-9">
        <njo-budget-consumption-chart [data]="chartData" [totalSpent]="totalSpent" [showTotalLabel]="showTotalLabel"
            [totalHoursAssigned]="order.hoursAssigned"></njo-budget-consumption-chart>
    </div>
</div>
<table *ngIf="order">
    <caption style="display: none;">Budget consumption table</caption>
    <tr>
        <th style="text-align: left;" scope="col">{{'order.budget.summary.name' | translate }}</th>
        <th style="text-align: left;" scope="col">{{'order.budget.summary.hoursAssigned' | translate }}</th>
        <th scope="col">{{'order.budget.summary.hoursSpent' | translate }}</th>
        <th scope="col">{{'order.budget.summary.hoursResidual' | translate }}</th>
        <th scope="col">{{'order.budget.summary.progress' | translate }}</th>
    </tr>
    <tr class="available-products" *ngFor="let budget of budgetsWithHoursAssigned">
        <td>{{budget.name}}</td>
        <td style="text-align: left;">{{budget.hoursAssigned}} ({{(budget.hoursAssigned / 8).toFixed(2) }}d)</td>
        <td>{{budget.hoursSpent}} ({{(budget.hoursSpent / 8).toFixed(2) }}d)</td>
        <td>{{budget.hoursResidual}} ({{(budget.hoursResidual / 8).toFixed(2) }}d)</td>
        <td>
            <progress-bar [progress]="(budget.hoursSpent / budget.hoursAssigned) * 100" [disable-percentage]="true"
                class="progress-form">
            </progress-bar>
        </td>
    </tr>

    <tr class="not-available-products" *ngFor="let budget of budgetsWithoutHoursAssigned">
        <td>{{budget.name}}</td>
        <td style="text-align: left;">{{budget.hoursAssigned}} ({{(budget.hoursAssigned / 8).toFixed(2) }}d)</td>
        <td>{{budget.hoursSpent}} ({{(budget.hoursSpent / 8).toFixed(2) }}d)</td>
        <td><span *ngIf="budget.hoursAssigned > 0">{{budget.hoursResidual}} ({{(budget.hoursResidual / 8).toFixed(2)
                }}d)</span>
            <span *ngIf="budget.hoursAssigned === 0">-</span>
        </td>
        <td>
            <progress-bar [progress]="0" [disable-percentage]="true" class="progress-form without-hours-progress">
            </progress-bar>
        </td>
    </tr>

</table>